class Environment {
  static get() {
    return new Environment().environment();
  }

  static prefix() {
    return new Environment().prefix();
  }

  constructor() {
    this.host = this._getHostname();
  }

  environment() {
    // Regex Playground: https://regex101.com/r/QRbH0j/1
    if (this.host.match(/^(\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})$/)) {
      return 'dev';
    }

    // Some devs mask their localhost with a "local." prefix
    if (this.host.indexOf('local.') > -1) {
      return 'dev';
    }

    if (this.host.indexOf('localhost') > -1) {
      return 'dev';
    }

    if (this.host.indexOf('test.') > -1) {
      return 'test';
    }

    if (this.host.indexOf('qa.') > -1) {
      return 'qa';
    }

    return 'prod';
  }

  prefix() {
    const mapping = { dev: 'test.', test: 'test.', qa: 'qa.', prod: '' };
    const env = this.environment();
    return mapping.hasOwnProperty(env) ? mapping[env] : '';
  }

  _getHostname() {
    return window.location.hostname;
  }
}

export default Environment;
